import React from 'react'

import styled from 'styled-components'
import { Button } from '../../../../../components/Submit/Submit.styles'

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

export const CancelButton = styled(Button)`
  background-color: #25a37b;
`

export const DeleteButton = styled(Button)`
  background-color: #f44336;
`

export const UL = styled.ul`
  padding: 20px;
`

export const LI = styled.li``
const WrapperListItem = styled.div`
  display: flex;
  justify-content: space-between;
`

const Label = styled.span`
  flex: 1;
`

const Description = styled.span`
  flex: 1;
  overflow: auto;
`

export const ListItem = ({ label, description }) => (
  <WrapperListItem>
    <Label>{label}</Label>
    <Description>{description}</Description>
  </WrapperListItem>
)
